import { addCC, fetchCards, selectCard, deleteCard } from 'shared/models/api';
import { track } from 'shared/models/analytic';
import Promise from 'bluebird';
import _ from 'lodash';

export const PAYMENT_LOADING = 'PAYMENT_LOADING';
export const PAYMENT_LOADED = 'PAYMENT_LOADED';
export const PAYMENT_ADD = 'PAYMENT_ADD';
export const PAYMENT_ADD_SHOW = 'PAYMENT_ADD_SHOW';
export const PAYMENT_PRIMARY_CARD = 'PAYMENT_PRIMARY_CARD';
export const PAYMENT_REMOVE_CARD = 'PAYMENT_REMOVE_CARD';

const init = { cards: [] };

export default function(state = init, action = {}) {
  switch (action.type) {
    case PAYMENT_LOADING:
      return { ...state, loading: true };
    case PAYMENT_LOADED:
      return { ...state, loading: false, cards: action.cards };
    case PAYMENT_ADD:
      return {
        ...state,
        cards: [action.card, ...(state.cards || [])],
        loading: false,
        cc_error: null,
        cardModal: false
      };
    case PAYMENT_ADD_SHOW:
      return { ...state, cardModal: action.show };
    case PAYMENT_PRIMARY_CARD:
      return { ...state, primaryCardId: action.cardId };
    case PAYMENT_REMOVE_CARD:
      return {
        ...state,
        cards: _.filter(state.cards, card => card.id !== action.cardId)
      };
    default:
      return state;
  }
}

export function addCard(element, data = {}) {
  return (dispatch, getState) => {
    return window.stripe.createToken(element, data).then(res => {
      if (res.error) {
        const cardError = new Error(res.error.message);
        cardError.name = 'CardError';
        return Promise.reject(cardError);
      }
      const token = res.token;
      return addCC(token.id)
        .then(() => {
          dispatch({ type: PAYMENT_ADD, card: token.card });
          track('Payment Info Entered', {
            checkout_id: getState().checkout.id
          });
          return token.card;
        })
        .catch(result => {
          const error =
            (result && result.body && result.body.message) ||
            'An unexpected error occurred.';
          return Promise.reject(new Error(error));
        });
    });
  };
}

export function showAddCard(show) {
  return dispatch => dispatch({ type: PAYMENT_ADD_SHOW, show: show });
}

export function loadCards() {
  return dispatch => {
    dispatch({ type: PAYMENT_LOADING });
    return fetchCards().then(res => {
      dispatch({ type: PAYMENT_LOADED, cards: res.cards });
    });
  };
}

export function makePrimaryCard(id) {
  return dispatch => {
    return selectCard(id).then(res => {
      dispatch({ type: PAYMENT_PRIMARY_CARD, cardId: res.id });
    });
  };
}

export function removeCard(id) {
  return dispatch => {
    return deleteCard(id).then(() => {
      dispatch({ type: PAYMENT_REMOVE_CARD, cardId: id });
    });
  };
}



// WEBPACK FOOTER //
// ./shared/components/payment/actions.js